import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ErrorMessage {
  message: string;
  type: 'error' | 'warning' | 'info';
  timestamp: Date;
  details?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private errorSubject = new BehaviorSubject<ErrorMessage | null>(null);
  public error$ = this.errorSubject.asObservable();

  constructor() {}

  handleError(error: any) {
    console.error('Ein Fehler ist aufgetreten:', error);

    let errorMessage: ErrorMessage = {
      message: 'Ein unerwarteter Fehler ist aufgetreten.',
      type: 'error',
      timestamp: new Date()
    };

    if (error.error instanceof ErrorEvent) {
      // Client-seitiger Fehler
      errorMessage = {
        message: 'Ein Fehler ist aufgetreten. Bitte überprüfen Sie Ihre Internetverbindung.',
        type: 'error',
        timestamp: new Date(),
        details: error.error.message
      };
    } else if (error.status) {
      // Server-seitiger Fehler
      switch (error.status) {
        case 400:
          errorMessage = {
            message: 'Ungültige Anfrage. Bitte überprüfen Sie Ihre Eingaben.',
            type: 'error',
            timestamp: new Date(),
            details: error.error?.message
          };
          break;
        case 401:
          errorMessage = {
            message: 'Sie sind nicht autorisiert. Bitte melden Sie sich erneut an.',
            type: 'error',
            timestamp: new Date()
          };
          break;
        case 403:
          errorMessage = {
            message: 'Zugriff verweigert. Sie haben keine Berechtigung für diese Aktion.',
            type: 'error',
            timestamp: new Date()
          };
          break;
        case 404:
          errorMessage = {
            message: 'Die angeforderte Ressource wurde nicht gefunden.',
            type: 'error',
            timestamp: new Date()
          };
          break;
        case 500:
          errorMessage = {
            message: 'Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
            type: 'error',
            timestamp: new Date()
          };
          break;
        default:
          errorMessage = {
            message: `Ein Fehler ist aufgetreten (${error.status}).`,
            type: 'error',
            timestamp: new Date(),
            details: error.error?.message
          };
      }
    }

    this.errorSubject.next(errorMessage);
  }

  showWarning(message: string, details?: string) {
    this.errorSubject.next({
      message,
      type: 'warning',
      timestamp: new Date(),
      details
    });
  }

  showInfo(message: string, details?: string) {
    this.errorSubject.next({
      message,
      type: 'info',
      timestamp: new Date(),
      details
    });
  }

  clearError() {
    this.errorSubject.next(null);
  }
} 